/**
 * Audit-log API — mirrors smt_audit_handler.go.
 *
 *   GET /api/v1/smt/admin/audit[?action=&target_type=&target_id=&actor=&limit=]
 */
import { requestData } from './client.ts';

export interface AuditEntry {
  id: number;
  ts: string;
  actor_user_id?: number | null;
  actor_label?: string | null;
  action: string;
  target_type?: string | null;
  target_id?: number | null;
  message?: string | null;
  details?: string | null;
  context?: string | null;
}

export interface ListAuditOptions {
  action?: string;
  target_type?: string;
  target_id?: number;
  actor?: number;
  limit?: number;
}

export async function listAudit(opts: ListAuditOptions = {}): Promise<AuditEntry[]> {
  return (
    (await requestData<AuditEntry[] | null>('/smt/admin/audit', {
      query: {
        action: opts.action,
        target_type: opts.target_type,
        target_id: opts.target_id,
        actor: opts.actor,
        limit: opts.limit,
      },
    })) ?? []
  );
}
